import {Injectable} from '@angular/core';
import {ApiService} from '../api.service';
import {ApiSmsTypeHelperService} from './sms-type-helper.service';
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class ApiSmsTypeService {
  constructor(public hpr: ApiSmsTypeHelperService,
              private _api: ApiService) {
  }

  get(id: number | string) {
    return this._api.get('sms-type/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('sms-type/list', data);
  }

  create(data: any) {
    return this._api.post('sms-type/create', data);
  }

  update(data: any) {
    return this._api.post('sms-type/update', data);
  }

  remove(id: number) {
    return this._api.post('sms-type/remove/id/' + id);
  }

  autocompleteSource(data = {}) {
    return (text?: string, id?: number) => {
      return this.list(text !== null ? {...data, text} : {ids: Array.isArray(id) ? id : [id]})
        .pipe(map((result) => result.data.map((item: any) => {
          return {
            id: item.id,
            label: item.name,
            data: item
          };
        })));
    };
  }
}
